import {
	AppBar,
	type SxProps,
	styled,
	type Theme,
	Toolbar,
} from "@mui/material";
import type { ReactElement } from "react";

const StyledAppBar = styled(AppBar)(({ theme }: { theme: Theme }) => ({
	zIndex: theme.zIndex.drawer + 1,
	color: theme.palette.text.primary,
	boxShadow: "none",
	backgroundColor:
		theme.palette.mode === "dark"
			? theme.palette.grey[100]
			: theme.palette.myPLANN.main10,
}));

const StyledToolbar = styled(Toolbar)`
  padding: 0;
`;

export interface MobileLayoutTopBarProps {
	topBar?: ReactElement;
	disableTopPadding?: boolean;
	topBarSx?: SxProps<Theme>;
}

export function MobileLayoutTopBar({
	topBar,
	topBarSx,
}: MobileLayoutTopBarProps) {
	if (!topBar) return null;

	return (
		<StyledAppBar
			elevation={2}
			position="static"
			sx={{ flexShrink: 0, ...topBarSx }}
		>
			<StyledToolbar>{topBar}</StyledToolbar>
		</StyledAppBar>
	);
}
